import type {GridSortModel} from '@mui/x-data-grid';

export const getOrdering = (sortModel: GridSortModel): string => {
  const {field, sort} = sortModel[0];
  return sort === 'asc' ? field : `-${field}`;
};

export const getSortModel = (ordering: string): GridSortModel => {
  const isDescending = ordering.startsWith('-');
  const field = isDescending ? ordering.slice(1) : ordering;
  const sort = isDescending ? 'desc' : 'asc';

  return [
    {
      field,
      sort,
    },
  ];
};
